export default __webpack_public_path__ + "static/leg_img_1-7f0ee1395d8f080b8e5cdca252ec970e.png";